import { render, staticRenderFns } from "./ViewUpdateAlert.vue?vue&type=template&id=2c3ce26d&scoped=true"
import script from "./ViewUpdateAlert.vue?vue&type=script&lang=js"
export * from "./ViewUpdateAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ce26d",
  null
  
)

export default component.exports